import React from 'react';
import { connect } from 'react-redux';
import { selectUser } from '../modules/auth.js';
import { retrieveOrganization } from '../modules/organizations.js';
import SubHeader from './SubHeader.jsx';
import { Link } from './Link.jsx';
import styles from './SurveyPageHeader.module.css';

const mapStateToProps = (state) => ({
  currentUser: selectUser(state),
});

const mapDispatchToProps = { retrieveOrganization };

const SurveyPageHeader = ({ logoUrl, orgName, brandStyles }) => {
  return (
    <header>
      <SubHeader
        bgWhite
        style={{
          height: '90px',
          padding: '0 30px',
          display: 'flex',
          alignItems: 'center',
        }}
      >
        {logoUrl ? (
          <Link route="/">
            <div
              className={`${styles.logo} cursor-pointer`}
              style={{ background: logoUrl }}
            />
          </Link>
        ) : (
          <h2 style={{ ...brandStyles }}>{orgName}</h2>
        )}
      </SubHeader>
    </header>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(SurveyPageHeader);
